import { Typography, Fade, Card, CardContent, CardActionArea, Collapse} from "@mui/material";
import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import { useState } from 'react';
import styles from "./TimelineCard.module.css";

export default function TimelineCard(props) {
    const icon = props.icon;
    const title = props.title;
    const company = props.company;
    const employmentType = props.employmentType;
    const year = props.year;
    const date = props.date;
    const description = props.description;
    const location = props.location;
    const current = props.current;

    const [isExpanded, setIsExpanded] = useState(false);

    const handleClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <TimelineItem>
            <TimelineOppositeContent>
                <Typography variant="subtitle1" color="#c2c2c2">{year}</Typography>
                {/* {isExpanded ? 
                    <>
                        <Typography variant="h6" color="rgba(255, 255, 255, 87)">{date}</Typography>
                        <Typography variant="subtitle2" color="rgba(170, 170, 170, 87)">{location}</Typography>
                    </> : 
                    <></>} */}
                <Fade in={isExpanded} unmountOnExit>
                    <div>
                        <Typography variant="h6" color="rgba(255, 255, 255, 87)">{date}</Typography>
                        <Typography variant="subtitle2" color="#c2c2c2">{location}</Typography>
                    </div>
                </Fade>
            </TimelineOppositeContent>
            <TimelineSeparator>
                {/* <TimelineConnector /> */}
                <TimelineDot color={current ? "success" : "info"}>
                    {icon}
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                <Card sx={{ backgroundColor: "#575757" }}>
                    <CardActionArea onClick={handleClick} >
                        <CardContent>
                            <Typography variant="h5" color="rgba(255, 255, 255, 87)" component="span">{title}</Typography>
                            <Typography variant="body1" color="#4dabf5">{company}</Typography>
                            <Typography variant="body1" color="#c2c2c2">{employmentType}</Typography>
                            {/* {isExpanded ? 
                                <>
                                    <Typography variant="body2" color="rgba(170, 170, 170, 87)" align="left" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>{description}</Typography>
                                </> :
                                <></>} */}
                            {/* <Fade in={isExpanded} unmountOnExit>
                                <div>
                                    <Typography variant="body2" color="rgba(170, 170, 170, 87)" align="left" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>{description}</Typography>
                                </div>
                            </Fade> */}
                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                <div>
                                    <Typography variant="body2" color="#c2c2c2" align="left" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>{description}</Typography>
                                </div>
                            </Collapse>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </TimelineContent>
        </TimelineItem>
    );
}